import { render, staticRenderFns } from "./AirWallexBtn.vue?vue&type=template&id=401a5805&scoped=true&"
import script from "./AirWallexBtn.vue?vue&type=script&lang=js&"
export * from "./AirWallexBtn.vue?vue&type=script&lang=js&"
import style0 from "./AirWallexBtn.vue?vue&type=style&index=0&id=401a5805&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a5805",
  null
  
)

export default component.exports